import styled from "styled-components";

export const HamburgerButton = styled.button`
  background-color: var(--calypso);
  color: var(--white);
  padding: 11px 11px 12px;
  border: 0;
  font-size: 16px;

  @media only screen and (min-width: 768px) {
    & {
      display: none;
    }
  }
`;
